import React from "react";
import Header from "./header";
import TeamprofileCard from "./TeamprofileCard";
import ContentLister from "./ContentLister";
import ContentContainerTab from "./ContentContainerTab";
import { useParams } from "react-router-dom";
import { useTeamProfile } from "../../api/teamprofile/queryHooks";
import { decodeId } from "../../api/utils";

function TeamprofilePage() {
  const id = decodeId(useParams()?.id);
  const { isError } = useTeamProfile(id);

  if (isError) return <div>Not Found</div>;

  return (
    <>
      <Header />
      <TeamprofileCard />
      <ContentLister />
      <ContentContainerTab />
    </>
  );
}

export default TeamprofilePage;
